import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import {
  campaignPipelineAPIClient,
  type ListCampaignInfluencersParams,
} from "../campaignPipelineAPIClient";
import { CAMPAIGN_PIPELINE_KEYS } from "./keys";

const PIPELINE_DEFINITIONS_STALE_TIME = 60 * 60 * 1000;

export const CAMPAIGN_PIPELINE_QUERIES = {
  definitions: () =>
    queryOptions({
      queryKey: CAMPAIGN_PIPELINE_KEYS.definitions(),
      queryFn: () => campaignPipelineAPIClient.listCampaignPipelines(),
      staleTime: PIPELINE_DEFINITIONS_STALE_TIME,
    }),
  list: (campaignId: string, params: ListCampaignInfluencersParams = {}) =>
    queryOptions({
      queryKey: CAMPAIGN_PIPELINE_KEYS.list(campaignId, params.stage),
      queryFn: ({ signal }) =>
        campaignPipelineAPIClient.listCampaignInfluencers(campaignId, params, signal),
      placeholderData: keepPreviousData,
      staleTime: 30 * 1000,
      enabled: campaignId !== "",
    }),
  detail: (campaignId: string, influencerId: string) =>
    queryOptions({
      queryKey: CAMPAIGN_PIPELINE_KEYS.detail(campaignId, influencerId),
      queryFn: () =>
        campaignPipelineAPIClient.getCampaignInfluencer(
          campaignId,
          influencerId,
        ),
      staleTime: 60 * 1000,
      enabled: campaignId !== "" && influencerId !== "",
    }),
};
